var _rect, _rect2, _g, _circle, _path;

var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};

var SvgEmailError = function SvgEmailError(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '35px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '35px' : _ref$height,
      originalSize = _ref.originalSize,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      rest = _objectWithoutProperties(_ref, _excluded);

  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 72,
    viewBox: "0 0 93 72",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92.987,
    height: 60.7,
    x: 0.007,
    y: 11.3,
    fill: "#fff",
    rx: 5.166
  })), /*#__PURE__*/React.createElement("mask", {
    id: "email-error_svg__a",
    width: 93,
    height: 62,
    x: 0,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 92.987,
    height: 60.7,
    x: 0.007,
    y: 11.3,
    fill: "#fff",
    rx: 5.166
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#email-error_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E2F1",
    d: "M42.211 52.87.007 19.05l-.969-5.812 94.924-.807-.969 6.296L52.01 52.784a7.749 7.749 0 0 1-9.798.087Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FEA09A",
    strokeLinejoin: "round",
    strokeWidth: 1.291,
    d: "M.007 72c14.121-11.6 22.685-18.427 36.807-30.027M92.993 72C78.871 60.4 70.308 53.573 56.186 41.973"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#FEA09A",
    strokeLinejoin: "round",
    strokeWidth: 1.291,
    d: "M41.941 52.222-.316 14.852v-5.65h93.632v5.65l-41.03 37.3a7.749 7.749 0 0 1-10.345.07Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.912,
    cy: 11.623,
    r: 10.332,
    fill: "#D0E2F1"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73.621,
    cy: 10.332,
    r: 10.332,
    fill: "#FE5348"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m74.772 6.135-.18 6.576h-1.678l-.183-6.576h2.04Zm-1.019 9.511c-.302 0-.562-.107-.78-.32a1.048 1.048 0 0 1-.32-.78c-.003-.3.104-.557.32-.77.218-.215.478-.322.78-.322.29 0 .546.107.766.321a1.052 1.052 0 0 1 .174 1.326c-.1.165-.233.298-.398.399a1.043 1.043 0 0 1-.542.146Z"
  })));
};

export { SvgEmailError as ReactComponent };
export default "/_next/static/media/email-error.71003070.svg";